var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { DataSource } from '@angular/cdk/table';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import * as Papa from 'papaparse';
import { BehaviorSubject } from 'rxjs';
var CsvPreviewComponent = /** @class */ (function () {
    function CsvPreviewComponent() {
        this.displayedColumns = new BehaviorSubject([]);
        this.data = new BehaviorSubject([]);
    }
    Object.defineProperty(CsvPreviewComponent.prototype, "results", {
        get: function () {
            return this._results;
        },
        set: function (value) {
            this._results = value;
            if (value) {
                this.form.disable();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsvPreviewComponent.prototype, "loading", {
        get: function () {
            return this._loading;
        },
        set: function (loading) {
            if (loading) {
                this.form.disable();
            }
            else if (!this.results) {
                this.form.enable();
            }
            this._loading = loading;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsvPreviewComponent.prototype, "file", {
        set: function (value) {
            if (value) {
                Papa.parse(value, {
                    header: true,
                    complete: this.initTable.bind(this),
                    skipEmptyLines: true
                });
            }
            else {
                this.initTable(null);
            }
        },
        enumerable: true,
        configurable: true
    });
    CsvPreviewComponent.prototype.initTable = function (result) {
        var _this = this;
        this.displayedColumns.next(this.config.map(function (col) { return col.property; }).concat(['action', 'result']));
        // Filter out rows that have duplicates of unique keys
        this.config.forEach(function (option) {
            var existing = new Set();
            if (option.unique) {
                result.data = result.data.filter(function (item) {
                    if (existing.has(item[option.property])) {
                        return false;
                    }
                    existing.add(item[option.property]);
                    return true;
                });
            }
            if (option.default) {
                result.data.forEach(function (item) { return (item[option.property] = item[option.property] || option.default); });
            }
        });
        this.rows = new FormArray(result.data.map(function (row) {
            var fg = new FormGroup({});
            _this.config.forEach(function (option) {
                fg.addControl(option.property, new FormControl(row[option.property]));
            });
            return fg;
        }), Validators.minLength(1));
        this.form.setControl('rows', this.rows);
        this.data.next(result.data);
        this.dataSource = new CsvDataSource(this.data.asObservable());
    };
    CsvPreviewComponent.prototype.controlForCell = function (index, property) {
        try {
            var item = this.rows.controls[index];
            return item.controls[property];
        }
        catch (ex) {
            return new FormControl('');
        }
    };
    CsvPreviewComponent.prototype.removeAt = function (idx) {
        this.rows.removeAt(idx);
        var items = this.data.value;
        this.data.next(items.slice(0, idx).concat(items.slice(idx + 1)));
    };
    CsvPreviewComponent.prototype.flattenError = function (result) {
        if (result.errors) {
            var errors = result.errors;
            try {
                for (var key in errors) {
                    if (Array.isArray(errors[key])) {
                        return "Failed (" + this.titleCase(key) + ": " + errors[key][0] + ")";
                    }
                }
            }
            catch (ex) { }
        }
        return 'Import failed.';
    };
    CsvPreviewComponent.prototype.titleCase = function (value) {
        return (value[0].toUpperCase() +
            value
                .replace(/([A-Z])/g, ' $1')
                .toLowerCase()
                .slice(1));
    };
    return CsvPreviewComponent;
}());
export { CsvPreviewComponent };
var CsvDataSource = /** @class */ (function (_super) {
    __extends(CsvDataSource, _super);
    function CsvDataSource(data) {
        var _this = _super.call(this) || this;
        _this.data = data;
        return _this;
    }
    CsvDataSource.prototype.connect = function () {
        return this.data;
    };
    CsvDataSource.prototype.disconnect = function () {
        // lint
    };
    return CsvDataSource;
}(DataSource));
export { CsvDataSource };
